import { SegmentFilterOption } from '../models/segments.model';
import { SEGMENT_FILTER_ATTRIBUTE, SEGMENT_FILTER_TYPE } from './segments.constant';

/**
 * Filter Bar Filter Type
 */
export enum FILTER_TYPE {
  ITEM = 'item',
  ITEMS = 'items',
  NUMBER_VALUE = 'numberValue',
  NUMBER = 'number',
  STRING_VALUE = 'stringValue',
  STRING = 'string',
  ITEM_VALUE = 'itemValue',
}

export const FILTER_CONFIGS: SegmentFilterOption[] = [
  /*
  ['device_sdk_android', 'Android EMMA SDK Version', 'attribute'],
  ['device_name_android', 'Android Device Model', 'attribute'],
  ['device_os_version_android', 'Android Version', 'attribute'],
  ['device_sdk_ios', 'iOS EMMA SDK Version', 'attribute'],
  ['device_name_ios', 'iOS Device Model', 'attribute'],
  ['device_os_version_ios', 'iOS Version', 'attribute'],
  ['device_udids', 'Device ID', 'attribute'],
  ['device_ids', 'EMMA ID', 'attribute'],
  ['user_country', 'Location: Country', 'attribute'],
  ['user_city', 'Location: City', 'attribute'],
  ['user_state', 'Location: State', 'attribute'],
  ['device_multiple', 'Multiple devices', 'attribute'],
  ['device_os', 'OS', 'attribute'],
  ['user_purchase_spent', 'Order value', 'attribute'],
  ['user_product_name', 'Product name', 'attribute'],
  ['user_push_open', 'Push Notification Open', 'attribute'],
  ['user_push_active', 'Push Notification Activated', 'attribute'],
  ['user_source', 'Source', 'attribute'],
  ['user_campaign', 'Campaign', 'attribute'],
  // fake events
  ['user_conversion', 'Conversion', 'aevent'],
  ['user_first_purchase', 'First purchase', 'aevent'],
  ['user_last_purchase', 'Last purchase', 'aevent'],
  ['user_last_session', 'Last seen', 'aevent'],
  ['user_install', 'Install', 'aevent'],
  // descomentar al reactivar
  // ["user_uninstall", "Uninstall", "aevent"],
  ['user_register', 'Register', 'aevent'],
  ['user_last_login', 'Last login', 'aevent'],
  ["communication", "Communication", "attribute"]
  */
  {
    label: SEGMENT_FILTER_ATTRIBUTE.DEVICE_APP_VERSION_IOS,
    type: SEGMENT_FILTER_TYPE.ATTRIBUTE,
    id: SEGMENT_FILTER_ATTRIBUTE.DEVICE_APP_VERSION_IOS,
  },
  {
    label: SEGMENT_FILTER_TYPE.USER_TAG,
    type: SEGMENT_FILTER_TYPE.USER_TAG,
    id: SEGMENT_FILTER_TYPE.USER_TAG,
  },
  {
    label: SEGMENT_FILTER_ATTRIBUTE.USER_CUSTOMERS,
    type: SEGMENT_FILTER_TYPE.ATTRIBUTE,
    id: SEGMENT_FILTER_ATTRIBUTE.USER_CUSTOMERS,
  },
  {
    label: SEGMENT_FILTER_TYPE.USER_EVENT,
    type: SEGMENT_FILTER_TYPE.USER_EVENT,
    id: SEGMENT_FILTER_TYPE.USER_EVENT,
  },
  {
    label: SEGMENT_FILTER_ATTRIBUTE.UNKNOWN,
    type: SEGMENT_FILTER_TYPE.UNSUPPORTED,
    id: SEGMENT_FILTER_ATTRIBUTE.UNKNOWN,
  },
];

/** @deprecated */
export enum FILTER_EXECUTION_STATUS {
  DONE = 0,
  IN_PROGRESS = 1,
  NONE = 2,
}
